import React from 'react';
import { Box, Breadcrumbs, Typography, IconButton, Tooltip, Badge, Link as MuiLink } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useLocation, Link } from 'react-router-dom';
import { pillars, topNavItems, bottomNavItems } from './navConfig';

// Map URL segments to display labels for parent paths that don't have their own nav item
// Map URL segments to display labels for parent paths that don't have their own nav item
const segmentLabels = {
  'knowledge-graph': 'Profile360',
  'graphrag': 'Explorer',
};

function useBreadcrumbs() {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) return [{ label: 'Overview', path: '/overview' }];

  const allItems = [
    ...topNavItems,
    ...pillars.flatMap((p) => [{ id: p.id, label: p.label, path: p.basePath }, ...p.items]),
    ...bottomNavItems,
  ];

  return segments.reduce((acc, seg) => {
    const path = (acc.length > 0 ? acc[acc.length - 1].path : '') + '/' + seg;
    const match = allItems.find((item) => item.path === path);
    acc.push({
      label: match?.label || segmentLabels[seg] || seg.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
      path,
    });
    return acc;
  }, []);
}

export default function TopBar() {
  const crumbs = useBreadcrumbs();

  return (
    <Box
      sx={{
        height: 56,
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
      }}
    >
      {/* Breadcrumbs */}
      <Breadcrumbs separator="›" sx={{ '& .MuiBreadcrumbs-separator': { color: 'text.disabled' } }}>
        {crumbs.map((crumb, i) =>
          i === crumbs.length - 1 ? (
            <Typography key={crumb.path} variant="body2" color="text.primary" fontWeight={600}>
              {crumb.label}
            </Typography>
          ) : (
            <MuiLink
              key={crumb.path}
              component={Link}
              to={crumb.path}
              underline="hover"
              variant="body2"
              color="text.secondary"
            >
              {crumb.label}
            </MuiLink>
          )
        )}
      </Breadcrumbs>

      {/* Right actions */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Tooltip title="Search (⌘K)">
          <IconButton size="small" sx={{ color: 'text.secondary' }}>
            <SearchIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Notifications">
          <IconButton size="small" sx={{ color: 'text.secondary' }}>
            <Badge badgeContent={3} color="error" variant="dot">
              <NotificationsNoneIcon fontSize="small" />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}
